import { getUserRoleAccess } from "../../api";

export async function checkScreenAccess(pathName: string) {
  const userRoleAccess = await getUserRoleAccess()
  // Normalize apiPath and check access
  if (userRoleAccess.isAdmin) return true
  const matchedAccess = userRoleAccess?.screenAccess?.find(access => {
    const normalizedScreen = access.screen.toLowerCase();
    const normalizedPathName = pathName.toLowerCase();
    const regex = new RegExp('^' + normalizedScreen.replace(/\*/g, '.*') + '$');
    return regex.test(normalizedPathName);
  });
  const hasAccess = !!matchedAccess && matchedAccess.isAuthorized;
  return hasAccess
}

export async function checkFunctionAccess(functionName: string) {
  const userRoleAccess = await getUserRoleAccess()
  // Normalize apiPath and check access
  if (userRoleAccess.isAdmin) return true
  const hasAccess = userRoleAccess?.functionAccess?.find(access =>
    access.function.toLowerCase() === functionName.toLocaleLowerCase() && access.isAuthorized
  ) !== undefined;
  return hasAccess
}

